import React, { useEffect, useState } from "react";
import { FiUsers } from "react-icons/fi";
import api from "../api";
import "./style/FollowersModal.css";

export default function FollowersModal({ isOpen, onClose, eventId, eventName }) {
  const [followers, setFollowers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen || !eventId) return;
    setLoading(true);
    api.get(`/followers/list?eid=${eventId}`)
      .then((r) => setFollowers(r.data.followers ?? []))
      .catch(() => setFollowers([]))
      .finally(() => setLoading(false));
  }, [isOpen, eventId]);

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="flm-overlay" onClick={onClose}>
      <div className="flm-card" onClick={(e) => e.stopPropagation()}>
        <button className="flm-close" onClick={onClose} aria-label="Close">✕</button>

        <div className="flm-header">
          <FiUsers size={16} className="flm-header__icon" />
          <h3 className="flm-header__title">
            {followers.length} {followers.length === 1 ? "Follower" : "Followers"}
          </h3>
          {eventName && <p className="flm-header__sub">{eventName}</p>}
        </div>

        <div className="flm-list">
          {loading ? (
            <p className="flm-empty">Loading…</p>
          ) : followers.length === 0 ? (
            <p className="flm-empty">No followers yet.</p>
          ) : (
            followers.map((f) => (
              <div key={f.user_id} className="flm-item">
                <div className="flm-item__avatar">
                  {f.display_name.charAt(0).toUpperCase()}
                </div>
                <span className="flm-item__name">{f.display_name}</span>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
